// Enum для типов квалификаций
export const QUALIFICATION_TYPES = {
  DOCTORAL_DEGREE: 'DOCTORAL_DEGREE',
  PROFESSIONAL_DEGREE: 'PROFESSIONAL_DEGREE',
  BACHELORS_DEGREE: 'BACHELORS_DEGREE',
  CERTIFICATE: 'CERTIFICATE',
  SPECIALIST_DEGREE: 'SPECIALIST_DEGREE',
  ASSOCIATE_DEGREE: 'ASSOCIATE_DEGREE',
  MASTERS_DEGREE: 'MASTERS_DEGREE',
};

// Маппинг для отображения (красиво)
export const QUALIFICATION_TYPE_LABELS = {
  [QUALIFICATION_TYPES.DOCTORAL_DEGREE]: 'Doctoral Degree (PhD)',
  [QUALIFICATION_TYPES.PROFESSIONAL_DEGREE]: 'Professional degree',
  [QUALIFICATION_TYPES.BACHELORS_DEGREE]: "Bachelor's degree",
  [QUALIFICATION_TYPES.CERTIFICATE]: 'Certificate',
  [QUALIFICATION_TYPES.SPECIALIST_DEGREE]: 'Specialist degree',
  [QUALIFICATION_TYPES.ASSOCIATE_DEGREE]: 'Associate degree',
  [QUALIFICATION_TYPES.MASTERS_DEGREE]: "Master's degree",
};

export const QUALIFICATION_TYPE_OPTIONS = Object.keys(QUALIFICATION_TYPES).map((key) => ({
  value: QUALIFICATION_TYPES[key],
  label: QUALIFICATION_TYPE_LABELS[QUALIFICATION_TYPES[key]],
}));

export const getQualificationTypeLabelByStringValue = (stringValue) => {
  return QUALIFICATION_TYPE_OPTIONS.find(
    (option) => option.label.toLowerCase() === stringValue.toLowerCase(),
  );
};

// Функция для получения label по enum
export const getQualificationTypeLabel = (enumValue) => {
  return QUALIFICATION_TYPE_LABELS[enumValue] || enumValue;
};

// Функция для получения enum по label
export const getQualificationTypeEnum = (label) => {
  const entry = Object.entries(QUALIFICATION_TYPE_LABELS).find(([, val]) => val === label);
  return entry ? entry[0] : label;
};

export const normalizeQualificationTypeForComparison = (type) => {
  const str = (type || '').toString().trim();
  if (!str) return '';
  if (Object.values(QUALIFICATION_TYPES).includes(str)) return str;
  const option = QUALIFICATION_TYPE_OPTIONS.find(
    (opt) => opt.label.toLowerCase() === str.toLowerCase(),
  );
  return option ? option.value : str;
};

// Проверка валидности типа
export const isValidQualificationType = (type) => {
  return Object.values(QUALIFICATION_TYPES).includes(type);
};

export const convertQualificationTypesForSelect = (qualificationTypes) => {
  return qualificationTypes.map((type) => ({
    value: type,
    label: QUALIFICATION_TYPE_LABELS[type] ?? type,
  }));
};
